import _ from "lodash";
import React from "react";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { Form, Modal, Segment, Grid, Radio, Label } from "semantic-ui-react";
import { yupResolver } from "@hookform/resolvers";
import NotRenewingModal from "../../../schemas/NotRenewingModal";
import { ControlledInput } from "../../../components/ControlledForm";

export const NotReNewingModal = (props: any) => {
  const { open, close, onSubmit, reasons, isLoading = false } = props;
  const { control, handleSubmit, errors, watch } = useForm({
    defaultValues: {
      reason: "",
      note: "",
    },
    resolver: yupResolver(NotRenewingModal),
  });
  const formContext = useForm({
    mode: "onChange",
  });
  const { formState } = formContext;
  const onError = (e: any) => {
    console.log("error =>", e);
  };

  const fieldError = (field: string) => {
    const message = _.get(errors, field);
    if (_.isEmpty(message)) {
      return undefined;
    }
    return {
      content: message,
      pointing: "below",
    };
  };

  return (
    <Modal
      open={open}
      size='tiny'
      header='Please list why you won’t be renewing this application'
      content={
        <FormProvider {...formContext}>
          <Segment basic>
            <Form>
              <Grid columns={2}>
                <Grid.Column width={16}>
                  <Form.Field>
                    <Controller
                      name='reason'
                      control={control}
                      defaultValue={""}
                      rules={{ required: "This field is required" }}
                      render={({ onChange, value }) => {
                        return (
                          <div className='ControlledRadioSelect'>
                            {reasons?.data.map((reason: any, index: number) => (
                              <Radio
                                key={index}
                                label={reason.attributes.name}
                                value={reason.attributes.name}
                                checked={value === reason.attributes.name}
                                onChange={() => onChange(reason.attributes.name)}
                              />
                            ))}
                            {!value && (
                              <Label basic prompt pointing='above'>
                                This field is required
                              </Label>
                            )}
                          </div>
                        );
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={16}>
                  <Form.Field
                    required={watch("reason").toLocaleLowerCase() === "other"}
                    error={fieldError("note.message")}
                  >
                    <ControlledInput control={control} required={true} type='text' name='note' label='Note' />
                  </Form.Field>
                </Grid.Column>
              </Grid>
            </Form>
          </Segment>
        </FormProvider>
      }
      actions={[
        { key: "cancel", content: "Cancel", secondary: true, onClick: () => close() },
        {
          key: "add",
          content: "Add",
          disabled: !formState?.isValid || isLoading,
          primary: true,
          onClick: handleSubmit(onSubmit, onError),
        },
      ]}
    />
  );
};
